
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import * as animationData from '@/assets/json/notice.json'
import lottieThis from 'vue-lottie'
@Component({
  name: 'rejectTip',
  components: {
    lottieThis,
  },
})
export default class indexView extends Vue {
  @Prop({ default: '' }) errorMessage!: string
  defaultOptions = { animationData: animationData }
  anim = {}
  handleAnimation(anim: any) {
    this.anim = anim
  }
}
